<template>
    <div class="flex">
        <transition>
            <div v-if="showSearch">
                <v-select
                    :options="resultList"
                    placeholder="Search Orders.."
                    id="global-search-input"
                    @search="onSearch"
                    :filterable="false"
                    @input="orderSelected"
                >
                    <template slot="no-options">
                        Type Order name or ID...
                    </template>
                    <template slot="option" slot-scope="option">
                        <div class="d-center" v-tooltip="'#' + option.id + ' ' + option.name">
                            {{ option.name }}
                        </div>
                    </template>
                </v-select>
            </div>
            <div v-else>

            </div>
        </transition>
<!--        <div>-->
<!--            <img class="search-icon" src="/images/search.svg" @click="showSearch = !showSearch"/>-->
<!--        </div>-->
    </div>
</template>

<script>
import axios from "axios";
import {debounce} from "lodash";

export default {
    name: "GlobalSearch",
    data: function () {
        return {
            showSearch: true,
            resultList: [],
        }
    },
    methods: {
        orderSelected: function (e){
            window.location = '/orders/' + e.order_id
        },
        onSearch(search, loading) {
            if (search.length < 3) {
                return;
            }

            loading(true);
            const BASE_URL = window.location.origin;
            const url = new URL(BASE_URL + '/search/orders');
            url.searchParams.append("query_string", search);
            url.searchParams.append("size", 20);

            axios.get(url.href)
                .then(
                    res => {
                        const data = res.data?.hits;
                        let filtered = [];
                        data.forEach((item) => {
                            let temp = item._source
                            temp.id = item._id
                            filtered.push(temp);
                        });
                        loading(false);
                        this.resultList = filtered;
                    }
                ).catch((e) => {
                console.error(e);
            });

        }
    }
}
</script>

<style scoped>

#global-search-input {
    width: 225px;
    height: 27px;
    font-size: 12px;
    margin: 0 6px;
    cursor: pointer;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.vs__dropdown-toggle {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: flex;
    padding: 0 0 5px;
    background: none;
    border: 1px solid rgba(60, 60, 60, .26);
    border-radius: 4px;
    white-space: normal;
}

.vs__search {
    cursor: pointer;
}

#global-search-input > .vs__no-options {
    font-size: 12px;
}

</style>
